import Action from './action';
import { equar } from '../../../utils/common';

const initialState = {
    usedPhone: [],
    errorTexts: []
}

export default (state = initialState, action: {type: string, playload: string[] | number}) => {
    switch (action.type) {
        case Action.UPDATE_USED_PHONE: {
            return {
                ...state,
                usedPhone: action.playload
            }
        }
        case Action.UPDATE_USED_PHONE_ERROR_TEXT: {
            try {
                const newErrors = (action.playload as string[] || []).filter(Boolean);
                const curErrors = state.errorTexts.filter(Boolean);
                if (!equar(newErrors, curErrors) && newErrors.length >= curErrors.length) {
                    (window as any).mailStats.show('used_phone_error', { errorText: action.playload })
                }
            } catch(e) {}
            return {
                ...state,
                errorTexts: action.playload
            }
        }
        case Action.UPDATE_USED_PHONE_ERROR_TEXT_BY_INDEX: {
            state.errorTexts.splice(action.playload as number, 1);
            return {
                ...state,
                errorTexts: [...state.errorTexts]
            }
        }
        default: return state;
    }
}
